import { Link } from "react-router-dom";

import ImgProductlevelmarketsize from "../../Visualize/ChartImages/ProductLevelMarketSize.png"
// import ImgProductlevelpocketgrowth from "../../Visualize/ChartImages/ProductLevelPocketGrowth.png"
import ImgProductlevelvolumeandrevenuegrowthtrends from "../../Visualize/ChartImages/ProductLevelVolumeAndRevenueGrowthTrends.png"
// import ImgProductlevelvolumeandrevenuedistribution from "../../Visualize/ChartImages/ProductLevelVolumeAndRevenueDistribution.png"
import ImgMargintrendsbyproduct from "../../Visualize/ChartImages/MarginTrendsByProduct.png"
// import ImgProductlevelimpactonvolumeandrevenuegrowth from "../../Visualize/ChartImages/ProductLevelImpactOnVolumeAndRevenueGrowth.png"

const ChartCard = ({ chart, categoryDisplayName }) => {

    const renderChartComponent = () => {
        if (chart.thumbnail) {
            return <img alt={chart.title} src={`data:${chart.thumbnailMimetype};base64,${chart.thumbnail}`} />;
        }
        switch (chart.title.toLowerCase()) {
          // case "market size by product and geography":
          //   return <img alt={ chart.title } src={ImgProductlevelmarketsize} />
          // case "pocket of growth by product and geography":
          //   return <img alt={ chart.title } src={ImgProductlevelpocketgrowth} />
          case "volume and revenue growth trends":
            return <img alt={ chart.title } src={ImgProductlevelvolumeandrevenuegrowthtrends} />
          // case "volume and revenue distribution trends":
          //   return <img alt={ chart.title } src={ImgProductlevelvolumeandrevenuedistribution} />
          case "margin trends by product":
            return <img alt={ chart.title } src={ImgMargintrendsbyproduct} />
          // case "impact on volume and revenue growth by product":
          //   return <img alt={ chart.title } src={ImgProductlevelimpactonvolumeandrevenuegrowth} />
          case "net flows by investor type and asset class":
            return <img alt={ chart.title } src={ImgProductlevelmarketsize} />
          case "net flows by geography and asset class":
              return <img alt={ chart.title } src={ImgProductlevelmarketsize} />
          case "aum by client segment and asset class":
            return <img alt={ chart.title } src={ImgProductlevelmarketsize} />
          case "aum by geography and asset class":
            return <img alt={ chart.title } src={ImgProductlevelmarketsize} />
          case "revenue by client segment and asset class":
            return <img alt={ chart.title } src={ImgProductlevelmarketsize} />
          case "revenue by geography and asset class":
            return <img alt={ chart.title } src={ImgProductlevelmarketsize} />
          case "market snapshot":
            return <img alt={ chart.title } src={ImgProductlevelvolumeandrevenuegrowthtrends} />
          default:
            return null;
        }
      };

    const routeSegment = chart.routeId ?? chart.title.split(' ').join('-');
    const chartPath = `/visualize/${routeSegment}` +
      (categoryDisplayName ? `?path=${encodeURIComponent(categoryDisplayName)}` : '');

    return (
        <div className="chart">
        <Link to={chartPath}>
             {renderChartComponent()}
                <div id={chart.title.split(' ').join('-')} className="chartTitle">{ chart.title }</div>
            </Link>
        </div>
    );
}

export default ChartCard;